{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Vos commentaires et suggestions nous aideront à améliorer notre produit et nos services.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "Si vous avez un problème technique ou de support, ou si vous avez besoin d'une assistance immédiate, veuillez contacter votre administrateur Laserfiche ou votre fournisseur de solutions comme indiqué dans votre contrat de service.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "Vous avez trouvé quelque chose que vous aimez ou n'aimez pas ? Faites-le nous savoir.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "Avez-vous une idée pour une nouvelle fonctionnalité ou une amélioration ? Nous sommes impatients de l'entendre.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Veuillez ne pas inclure d'informations confidentielles ou personnelles dans vos commentaires",
  "TELL_US_ABOUT_EXPERIENCE": "Parlez-nous de votre expérience",
  "TELL_US_ABOUT_IDEA": "Parlez-nous de votre idée",
  "I_HAVE_FEEDBACK": "J'ai des commentaires",
  "I_HAVE_SUGGESTION": "J'ai une suggestion",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "Vous pouvez me contacter à propos de ces commentaires",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "Si vous souhaitez rejoindre notre panel de clients,",
  "PLEASE_CLICK_HERE": "veuillez cliquer ici.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "L'image dépasse la taille maximale de fichier de {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "L'image est corrompue ou dans un format non reconnu.",
  "ACCEPTED_FORMATS_ARE_0": "Les formats acceptés sont : {0}.",
  "IMAGE_NOT_ATTACHED": "Image non jointe.",
  "ATTACH_IMAGE": "Joindre une image",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Veuillez joindre une seule image.",
  "TAGS": "Étiquettes",
  "ADD_TAGS": "Ajouter des étiquettes",
  "ADD_MORE_TAGS": "Ajouter plus d’étiquettes",
  "NO_TAGS_AVAILABLE": "Aucune étiquette disponible"
}
